import Vue from 'vue'
import Vuex from 'vuex'

import * as modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({

  strict: process.env.NODE_ENV !== 'production',

  modules: {
    ...modules
  },

  getters: {
    isPopupOpened: state => state.menu.opened || state.form.opened,
    isPopupAnimating: (state, getters) => getters['app/isAnimating']
  },

  mutations: {
    openPopup: (state, popup) => {
      state[popup].opened = true
    },

    closePopup: (state, routeChanged) => {
      state.menu.opened = state.form.opened = false

      if (routeChanged) {
        state.app.routeChangedFromPopup = true
      } else {
        state.app.routeChangedFromPopup = false
      }
    }
  }

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js